export const GET_FORTNOX_LABELS = "GET_FORTNOX_LABELS"
export const GET_FORTNOX_LABELS_SUCCESS = "GET_FORTNOX_LABELS_SUCCESS"
export const GET_FORTNOX_LABELS_ERROR = "GET_FORTNOX_LABELS_ERROR"
